// extracted by mini-css-extract-plugin
export var centerText = "_63-8";
export var container = "_63-0";
export var doughnutContainer = "_63-7";
export var legend = "_63-a";
export var legendItemColorDisplay = "_63-b";
export var legendItemLabel = "_63-d";
export var legendItemValue = "_63-c";
export var lg = "_63-5";
export var maxWidth = "_63-9";
export var md = "_63-4";
export var responsive = "_63-6";
export var sm = "_63-3";
export var xs = "_63-2";
export var xxs = "_63-1";